import { render, staticRenderFns } from "./about_page.vue?vue&type=template&id=1ef7f8c6&scoped=true"
import script from "./about_page.vue?vue&type=script&lang=js"
export * from "./about_page.vue?vue&type=script&lang=js"
import style0 from "./about_page.vue?vue&type=style&index=0&id=1ef7f8c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef7f8c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ef7f8c6')) {
      api.createRecord('1ef7f8c6', component.options)
    } else {
      api.reload('1ef7f8c6', component.options)
    }
    module.hot.accept("./about_page.vue?vue&type=template&id=1ef7f8c6&scoped=true", function () {
      api.rerender('1ef7f8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/about_page.vue"
export default component.exports